//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import Top from '../price/_top'
import Detail from './_detail'
import Consultants from '@/components/business/_excellent_consultants'
import { handleItem } from '../price/utils'
import CommonSelect from '@/components/form/common_select'
import { errorLog } from '@/utils/log'
export default {
    components: {
        Top,
        Detail,
        Consultants,
        CommonSelect
    },
    data () {
        return {
            loading: true,
            detail: {
                building: {
                    name: '',
                    id: ''
                },
                area: '',
                decorate_price: 0,
                decoration_type: '',
                house_decorate_prices: [],
                inside_area: '',
                layout: '',
                name: '',
                square_price: '',
                usage: '',
                water_price: '',
                show_decorate_price: 0
            },
            house_decorate_prices: [],
            show_decorate_select: false,
            selected_decorate_price: 0,
            downpayment_percentage: [],
            decorate_price: 0,
            excellent_consultants: [],
            type: ''
        }
    },
    created () {
        this.getData()
    },
    methods: {
        changeItemDecorate (index) {
            this.selected_decorate_price = index
            this.detail = handleItem(this.detail, {
                decorate_price: this.house_decorate_prices[index].value,
                downpayment_percentage: this.downpayment_percentage
            })
        },
        toggleDecorateSelect () {
            this.show_decorate_select = !this.show_decorate_select
        },
        getData () {
            const { house_id, price_id, type } = this.$route.query
            let method = 'getPriceDetail'
            this.type = type
            if (type === 'surplus_apartments') {
                method = 'getSurplusPriceDetail'
            }
            this.$wx.showLoading()
            Service[method](house_id, price_id).then((data) => {
                this.house_decorate_prices = data.house_decorate_prices.map(({ decorate_price, decorate_type, layout_type }) => {
                    return {
                        value: decorate_price,
                        text: `${decorate_price}元/㎡（${decorate_type}，适用${layout_type}）`
                    }
                })
                this.house_decorate_prices.some(({ value }, index) => {
                    if (value === data.decorate_price) {
                        this.selected_decorate_price = index
                        return true
                    }
                })
                this.decorate_price = this.house_decorate_prices.length ? this.house_decorate_prices[this.selected_decorate_price].value : 0
                this.downpayment_percentage = data.downpayment_percentage
                this.detail = handleItem(data, {
                    decorate_price: this.decorate_price || 0,
                    downpayment_percentage: this.downpayment_percentage
                })
                this.loading = false
                this.$wx.hideLoading()
            }).catch(err => {
                errorLog(`get_building_price_error ${JSON.stringify(err)}, options: ${JSON.stringify(this.$route.query)}`)
            })
        }
    }
}
